import { render, staticRenderFns } from "./disease_page.vue?vue&type=template&id=a04f1ab0&scoped=true"
import script from "./disease_page.vue?vue&type=script&lang=js"
export * from "./disease_page.vue?vue&type=script&lang=js"
import style0 from "./disease_page.vue?vue&type=style&index=0&id=a04f1ab0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04f1ab0",
  null
  
)

export default component.exports